module.exports = __webpack_public_path__ + "img/config.5d6cd015.png";